import OutsideClickHandler from "react-outside-click-handler/build/OutsideClickHandler";

/**
 * The little pop-out menu behind a row's three-dots button.
 *
 * It used to be a 30px-wide column of 14–15px images with no padding around
 * them, so the clickable area was the glyph itself — accurate to within a few
 * pixels, and easy to miss. Each item is now a 32px square target with a hover
 * state; the glyph inside stays small, so the menu reads the same but is
 * comfortable to hit.
 */
export function ActionMenu({ onClose, children }) {
  return (
    <OutsideClickHandler onOutsideClick={onClose}>
      <div className="flex flex-col items-center p-[4px] gap-[2px] absolute top-[24px] right-0 w-[40px] border-[1px] rounded-[6px] border-borderColor bg-white z-20 shadow-md">
        {children}
      </div>
    </OutsideClickHandler>
  );
}

/**
 * One item. `title` is both the tooltip and the accessible label — these menus
 * are icon-only, so it should always be set.
 */
export function ActionMenuItem({ onClick, title, children }) {
  return (
    <div
      onClick={onClick}
      title={title}
      role="button"
      aria-label={title}
      className="w-[32px] h-[32px] flex items-center justify-center rounded-[4px] cursor-pointer hover:bg-[#F1F3F9] transition-colors"
    >
      {children}
    </div>
  );
}

/** Convenience for the common case: an image glyph inside a menu item. */
export function ActionMenuIcon({ onClick, title, src, size = 17 }) {
  return (
    <ActionMenuItem onClick={onClick} title={title}>
      <img src={src} alt={title} className="object-contain" style={{ width: size, height: size }} />
    </ActionMenuItem>
  );
}

export default ActionMenu;
